// export const getGmailSignedUrl = async () => {
//   try {
//     const res = await axios.get(`${apiUrl}/youtube/gmail-signed-url`)
//     return res.data
//   } catch (error) {
//     return errorMiddleware(error)
//   }
// }

import { client } from "@/services/v2/client"
import { useQuery } from "@tanstack/react-query"
import { useUser } from "containers/user/hooks/useUser"
import { UserQueryKeys } from "containers/user/types/user"

const baseUrl = `/api/v1/youtube`


export const useFetchGoogleUrl = () => {

  return useQuery({
    queryKey: [UserQueryKeys.CONNECTIONS, 'gmail-url'],
    queryFn: () => {
      return client<{ url?: string }>(`${baseUrl}/gmail-signed-url`)
    },
  })
}

export const useGoogleConnectedStatus = () => {
  const { user } = useUser()

  return useQuery({
    queryKey: [UserQueryKeys.CONNECTIONS, 'gmail-connection-status', user?.id],
    queryFn: () => client<{gmailConnected?: boolean}>(`${baseUrl}/gmail-connection-status`),
    enabled: !!user?.id,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchIntervalInBackground: true,
    staleTime: 0,
    cacheTime: 0,
  })
}